// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0e91c856","453":"2942c2bf"}[chunkId] + ".chunk.js";
};